import { defineStore } from 'pinia'
import api from '@/utils/api'

export const useSettingsStore = defineStore('settings', {
  state: () => ({
    settings: JSON.parse(localStorage.getItem('site_settings')) || {
      site_name: 'LapShop',
      site_description: 'Premium Laptop Parts & Accessories',
      contact_email: 'support@lapshop.com',
      contact_phone: '+91 99301 69930',
      address: 'New Delhi, India',
      currency: 'INR',
      facebook: null,
      twitter: null,
      instagram: null,
      youtube: null,
      maintenance_mode: false
    },
    loading: false,
    error: null
  }),

  getters: {
    getSetting: (state) => (key) => {
      return state.settings[key]
    }
  },

  actions: {
    async fetchSettings() {
      this.loading = true
      this.error = null
      try {
        const response = await api.get('/settings')
        if (response.data && response.data.data) {
          this.settings = { ...this.settings, ...response.data.data }
          localStorage.setItem('site_settings', JSON.stringify(this.settings))
        }
      } catch (error) {
        console.error('Failed to fetch settings:', error)
        this.error = error.response?.data?.message || 'Failed to load settings'
      } finally {
        this.loading = false
      }
    },

    async updateSettings(settingsData) {
      this.loading = true
      this.error = null
      try {
        const response = await api.put('/admin/settings', settingsData)
        if (response.data && response.data.data) {
          this.settings = { ...this.settings, ...response.data.data }
          return response.data
        }
      } catch (error) {
        console.error('Failed to update settings:', error)
        this.error = error.response?.data?.message || 'Failed to update settings'
        throw error
      } finally {
        this.loading = false
      }
    }
  }
})
